import React from 'react';
import { Box, Typography, Tooltip, IconButton, ClickAwayListener } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { CheckCircleOutline, DeleteOutline, MoreVertOutlined } from '@material-ui/icons';
import { tooltipStyles } from '../../../../common/styles/Tooltip';

const useStyles = makeStyles(() =>
  createStyles({
    menuItem: {
      display: 'flex',
      padding: '0.5rem',
      borderRadius: '4px',
      cursor: 'pointer',
      alignItems: 'center',
      '&:hover': {
        opacity: 0.75,
      },
    },
    menuItemText: {
      marginLeft: '0.75rem',
      fontSize: '14px',
    },
  })
);

export type RoleApplicationAction = 'approve' | 'reject';

interface Props {
  onAction: (action: RoleApplicationAction) => void;
  bulk: boolean;
  approveLabel?: string;
}

export function RoleApplicationsMenu({ onAction, bulk, approveLabel }: Props) {
  const classes = useStyles();
  const approveText = approveLabel ?? (bulk ? 'Approve all' : 'Approve');
  return (
    <Box>
      <Box className={classes.menuItem} onClick={() => onAction('approve')}>
        <CheckCircleOutline fontSize='small' />
        <Typography className={classes.menuItemText}>{approveText}</Typography>
      </Box>
      <Box className={classes.menuItem} onClick={() => onAction('reject')}>
        <DeleteOutline fontSize='small' />
        <Typography className={classes.menuItemText}>{bulk ? 'Reject all' : 'Reject'}</Typography>
      </Box>
    </Box>
  );
}

export function RoleApplicationsMenuButton({ onAction, bulk, approveLabel }: Props) {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const onCloseMenu = (e: any) => {
    e.stopPropagation();
    setMenuOpen(false);
  };
  const onOpenMenu = (e: any) => {
    e.stopPropagation();
    setMenuOpen(true);
  };

  const classes = tooltipStyles();

  return (
    <ClickAwayListener onClickAway={onCloseMenu}>
      <Tooltip
        arrow
        interactive
        title={<RoleApplicationsMenu onAction={onAction} bulk={bulk} approveLabel={approveLabel} />}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        placement='bottom-end'
        open={menuOpen}
        onClose={onCloseMenu}
        onOpen={onOpenMenu}
        classes={classes}
      >
        <IconButton onClick={onOpenMenu} style={{ color: '#0000008A', padding: '0.5rem' }}>
          <MoreVertOutlined />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
}
